import { render, staticRenderFns } from "./RecipientEvent.vue?vue&type=template&id=6021c3b0&"
import script from "./RecipientEvent.vue?vue&type=script&lang=js&"
export * from "./RecipientEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports